<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144058' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144059' | translate}}</mat-label>
            <textarea matInput placeholder="" formControlName="abstract" rows="3"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151201' | translate}}</mat-label>
            <textarea matInput placeholder="" formControlName="coachingResult" rows="2"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="margin-bottom: 16px;">
        <div class="col">
          <mat-checkbox formControlName="driver3PLflag">
            {{'ml_153258' | translate}}
          </mat-checkbox> 
        </div>        
      </div>
      
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144064' | translate}}</mat-label>
            <input matInput placeholder="{{'ml_144078' | translate}}" formControlName="mentorId"
              (keyup)="onMentorNameKeyUp($event)" />
          </mat-form-field>
        </div>
        <div class="col">
          <div class="mt-3">{{ editForm.controls["mentorName"].value }}</div>
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144065' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="mentorName" />
          </mat-form-field> -->
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <app-user-profile-search-grid [filterText$]="mentorNameFilter$"
            (itemToggled)="onMentorItemClicked($event)"></app-user-profile-search-grid>
        </div>
      </div>

      <div class="row" *ngIf="!is3pl">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144066' | translate}}</mat-label>
            <input matInput placeholder="{{'ml_144051' | translate}}" formControlName="driverApexId"
              (keyup)="onDriverNameKeyUp($event)" />
          </mat-form-field>
        </div>
        <div class="col">
          <div class="mt-3">{{ editForm.controls["driverName"].value }}</div>
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144067' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="driverApexId" />
          </mat-form-field> -->
        </div>
      </div>
      <div class="row mb-3" *ngIf="!is3pl">
        <div class="col">
          <app-driver-search-grid [filterText$]="driverApexIDOrNameFilter$"
            (itemToggled)="onDriverItemClicked($event)"></app-driver-search-grid>
        </div>
      </div>      

      <div class="row" *ngIf="is3pl">    
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144113' | translate}}</mat-label>
            <mat-select formControlName="driver3PLterminal_Id">
              @for (item of terminalSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144061' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="emIncidentNumber" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144062' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="driver3pl" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_143958' | translate)}}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="coachingtime">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        @if(!isCreate){
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ml_144072' | translate}}</mat-label>
            <mat-select formControlName="status">
              @for (item of statusSelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>

      <div class="row mt-3">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100 file-selector">
            <mat-label>{{'ml_144011' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="attachment" />
            <button type="button" mat-raised-button (click)="fileInput.click()">{{'ml_144144' | translate}}</button>
            <span class="ms-3">{{ 'ml_151172' | translate }}</span>
            <div>
              <mat-checkbox class="attachment-visible" formControlName="attachmentVisibletoDriver">{{'ml_151202' |
                translate}}</mat-checkbox>
            </div>
          </mat-form-field>
          <input hidden (change)="onFileSelected($event)" type="file" #fileInput id="file">
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid"
      label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}" (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' |
      translate }}</button>
  </div>
</div>